import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./reducers/accounts/auth";
import { userReducer } from "./reducers/accounts/user";
import { pagemetaReducer } from "./reducers/pagemetaReducer";
import { productReducer } from "./reducers/ProductReducer";

const reducer = {
  // page
  page: pagemetaReducer,

  products: productReducer,

  // Accounts
  auth: authReducer,
  user: userReducer,
};

const store = configureStore({
  reducer: reducer,
});

export default store;
